export function isContentFragmentArray(field) {
    return (Array.isArray(field) &&
        (field.length === 0 || (field.length > 0 && isContentFragment(field[0]))));
}
export function isContentFragment(field) {
    return Boolean(field && Object.prototype.hasOwnProperty.call(field, 'fields'));
}
//# sourceMappingURL=content-fragment.js.map